import formatTime from "../hooks/formatTime";
import { useTimerState } from "../../TimerContext";
type RenderBoardLogoProps = {
  isGameStarted: boolean;
  isGameFinished: boolean;
  onStart: () => void;
  onNext: () => void;
  type: 1|2|3;
};
type BoardButtonProps = {
  isGameStarted: boolean;
  isGameFinished: boolean;
  onStart: () => void;
  onNext: () => void;
  type: 1|2|3;
};
const BoardButton = ({
  isGameStarted,
  isGameFinished,
  onStart,
  onNext,
  type,
}: BoardButtonProps) => {
  if (!isGameStarted) {
    return (
      <button
        title="Начать игру"
        className="tableS-buttonCheck"
        onClick={() => {
          onStart();
        }}
      >
        Начать игру
        <img alt="" className="tableS-logoRun" src="/img/button/run-fix.svg" />
      </button>
    );
  }
  if (isGameFinished) {
    return (
      <button className="tableS-buttonCheck" onClick={onNext}>
        Играть ещё
        <img alt="" className="tableS-logoRun" src="/img/button/run-fix.svg" />
      </button>
    );
  }
  if(type===3){
      return (
      <button className="tableS-buttonCheck" onClick={onNext}>
        Далее
        <img alt="" className="tableS-logoRun" src="/img/button/run-fix.svg" />
      </button>
    );
  }
  return null;
};
const RenderBoardLogo: React.FC<RenderBoardLogoProps> = ({
  isGameStarted,
  isGameFinished,
  onNext,
  onStart,
  type,
}) => {
  const { time, isTimerRunning } = useTimerState();
  return (
    <div className="tableS-board-logo">
      <img
        alt="logo"
        src="/img/transpos/person-transpos.svg"
        className="tableS-board-logo-image"
      ></img>

      <p className="tableS-subtitle" id="tableS-subtitle-board-logo">
        {isGameStarted && `Таймер: ${formatTime(time)}`}
      </p>
      <div id="tableS-board-logo-button">
        {!isTimerRunning && (
          <BoardButton
            isGameStarted={isGameStarted}
            isGameFinished={isGameFinished}
            onStart={onStart}
            onNext={onNext}
            type = {type}
          />
        )}
      </div>
    </div>
  );
};
export default RenderBoardLogo;
